<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="animation">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Animations culinaires
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#515f77;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Croustillance égaie vos repas professionnels </h2>
                                        <p>
                                            Nous pouvons vous proposer différentes <b>animations
                                            culinaires</b> comme :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                La cuisson à la plancha
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                La confection de blinis à la russe
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                La découpe de jambons crus de prestige
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                La confection de burgers
                                            </li>
                                        </ul>
                                        </p>
                                        <p>
                                            Pour agrémenter vos pauses ou conclure vos repas professionnels sur une note
                                            gourmande, nous vous suggérons également nos <b>animations sucrées</b> :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Atelier de confection de pavlovas
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Fontaines de chocolat
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Candies bars
                                            </li>
                                        </ul>
                                        </p>
                                        <p>
                                            Toutes nos animations culinaires sont conçues comme de petits spectacles.
                                            Elles <b>marquent les esprits</b> de vos invités et donnent une image
                                            positive de votre entreprise ou de votre collectivité.
                                        </p>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/animations/animation-culinaire.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4" style="background:#f2b092;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Divertissant</h3>
                                        <p>
                                            Nos animations sont conçues comme de petits divertissements qui raviront les yeux et les papilles de vos invités. Selon les formules, les convives pourront participer à la confection de leur plat en choisissant les sauces, les condiments, les décors qui leur plaisent.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/animations/Cochon-grille.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/animations/Cochon-grille.jpg" alt="An image"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/animations/Cochon-grille.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-color:#7bc5d7">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">

                                        <p style="font-size: 35px; font-family: Nunito, sans-serif; font-weight: bold;">
                                            Intrigués, amusés par nos démonstrations, vos convives se rappelleront longtemps de votre événement d’entreprise.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/animations/quentin-au-buffet.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/animations/quentin-au-buffet.jpg" alt="An image"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/animations/quentin-au-buffet.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4" style="background:#8e6666;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6">Objectif goût</h3>
                                        <p>
                                            Lors de ces animations ludiques et festives, Croustillance conserve à l’esprit son objectif numéro 1 : vous régaler.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/animations//wok.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-img">
                                    <div class="mask"></div>
                                    <img class="img-block" src="img/animations//wok.jpg" alt="Animation wok"
                                         style="display: none;">
                                    <div class="img"
                                         style="background-image: url('img/animations//wok.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                                </div>
                                <div class="media-body align-top">
                                    <div class="desc">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'evenements',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        }
        ,
        created() {
            document.getElementsByTagName('meta')["description"].content = "Croustillance rythme vos pauses et vos repas professionnels grâce à différentes animations culinaires : planchas, atelier blinis & burger, découpe de jambons, etc.";
            document.title = "Animations culinaires pour les professionnels | Croustillance";
        }
    }
</script>

<style>
    #animation {
        background: url('/img/animations/animations-evenements.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>